import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
// import ReserveTable from "../../pages/reservation/reserve";
import logo from "../../assets/images/logo.png";

const navigationItems = [
  { name: "HOME", href: "/" },
  { name: "360 VIEW", href: "/360-degree" },
  { name: "ABOUT US", href: "/about-us" },
  { name: "GALLERY", href: "/gallery" },
  { name: "CONTACT", href: "/contact-us" },
  { name: "CATALOG", href: "/catalog" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const location = useLocation();
  const [activeNav, setActiveNav] = useState(location.pathname);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setActiveNav(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Disclosure
        as="nav"
        className={`bg-black/70 ${
          scrolled ? "fixed top-0 left-0 right-0 z-50" : ""
        }`}
      >
        <div
          className={`relative z-[11] mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 transition-all duration-300 ${
            scrolled
              ? "bg-gradient-to-b from-black/70 to-black/40 backdrop-blur-sm"
              : ""
          }`}
        >
          <div className="relative flex h-16 items-center justify-between">
            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
              <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <Bars3Icon
                  aria-hidden="true"
                  className="block size-6 group-data-[open]:hidden"
                />
                <XMarkIcon
                  aria-hidden="true"
                  className="hidden size-6 group-data-[open]:block"
                />
              </DisclosureButton>
            </div>

            <div className="flex flex-1 items-center justify-end">
              <div className="flex shrink-0 items-center">
                <Link to="/">
                  <img alt="Your Company" src={logo} className="h-12 w-auto" />
                </Link>
              </div>
              <div className="hidden sm:block ml-auto">
                <div className="flex items-center space-x-4">
                  {navigationItems.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setActiveNav(item.href)}
                      className={classNames(
                        activeNav === item.href
                          ? "text-amber-600 relative after:content-['....'] after:absolute after:bottom-[-10px] after:left-[79%] after:text-amber-600 after:tracking-[-0.9em] after:text-2xl"
                          : "text-pink-500 hover:text-amber-600 relative",
                        "px-3 py-2 text-md font-medium hover:after:absolute hover:after:content-['....'] hover:after:bottom-[-10px] hover:after:text-amber-600 hover:after:left-[70%] hover:after:tracking-[-0.9em] hover:after:text-2xl"
                      )}
                    >
                      {item.name}
                    </Link>
                  ))}
                  <Link
                    className="bg-amber-400 px-3 py-2 rounded-full text-white font-semibold"
                    to="/make-reservation"
                  >
                    Make Reservation
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DisclosurePanel className="sm:hidden">
          <div
            className={`space-y-1 px-2 pb-3 pt-2 flex flex-col items-center ${
              scrolled ? "bg-gradient-to-b from-black/70 to-black/40" : ""
            }`}
          >
            {navigationItems.map((item) => (
              <DisclosureButton
                key={item.name}
                as={Link}
                to={item.href}
                onClick={() => setActiveNav(item.href)}
                className={classNames(
                  activeNav === item.href
                    ? "text-amber-600"
                    : "text-pink-700 hover:text-amber-600",
                  "block rounded-md px-3 py-2 text-base font-medium text-center"
                )}
              >
                {item.name}
              </DisclosureButton>
            ))}
            <Link
              className="bg-amber-400 px-3 py-2 rounded-full text-white font-semibold"
              to="/make-reservation"
            >
              Make Reservation
            </Link>
          </div>
        </DisclosurePanel>
      </Disclosure>
    </>
  );
}
